module.exports = __webpack_public_path__ + "static/media/logo.5f4c45fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 116
// module chunks = 0